import SendAnnouncement from 'pages/Annoucement/SendAnnouncement';
import { useLocation } from 'react-router-dom';

const CreateAnnouncementContainer = () => {
    const location = useLocation();
    const group = location.state?.group;
    const defaultValues = {
        title: '',
        message: '',
        groupId: group?.id ? String(group.id) : null,
    };
    return <SendAnnouncement defaultValues={defaultValues} />;
};

export default CreateAnnouncementContainer;
